import { APIClient } from "api/api_helper";
import { CRF_API, CRF_ASSIGNMENT_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";
import { CRFItem } from "modules/Library/CRF/helpers/crf.types";

// ------------------------------------------------------------------
// API CLIENT
// ------------------------------------------------------------------ */

const api = new APIClient();

// ------------------------------------------------------------------
// CRF API
// ------------------------------------------------------------------

export const crfApiService = {
    // SELECT ALL METHOD
    getSelectAllData: (
        otherid?: number | null,
        searchText?: string | null,
        pageNumber: number = 1,
        pageSize: number = 10,
    ) => {
        const payload = {
            otherid: otherid,
            status: "A",
            searchtext: searchText || null,
            currentpage: pageNumber,
            pagesize: pageSize,
        
        };
        return api.create(CRF_API.CRF_API + "SelectAll", payload);
    },

    // SELECT METHOD
    getSelectData: (id: number) => {
        const user = GetUserData() as CurrentUser;
        const payload ={
            crfid: id,
        }
        return api.create(CRF_API.CRF_API + "Select", payload);
    },

    // INSERT METHOD
    insertData: (payload_data: CRFItem) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            name: payload_data.name,
            json: payload_data.json,
            createdby: user.userid,
        };
        return api.create(CRF_API.CRF_API + "Insert", payload);
    },

    // UPDATE METHOD
    updateData: (payload_data: CRFItem) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            ...payload_data,
            updatedby: user.userid,
        };
        return api.create(CRF_API.CRF_API + "Update", payload);
    },

    // DELETE METHOD
    deleteData: (payload_data: { crfid: number | null; updatereason: string; }) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            crfid: payload_data.crfid,
            updatereason: payload_data.updatereason,
            updatedby: user.userid,
        };
        return api.create(CRF_API.CRF_API + "Delete", payload);
    },

    // DROPDOWN METHOD
    getDropdownData: () => {
        const payload = {
        };
        return api.create(CRF_API.CRF_API + "Dropdown", payload);
    },

    // CRF ASSIGNMENT 
    assignCRFInsert: (payload_data: { moduleid: number | string; crfids: (number | string)[]; }) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            moduleid: payload_data.moduleid,
            crfids: payload_data.crfids,
            createdby: user?.userid,
        };
        return api.create(CRF_ASSIGNMENT_API.MODULE_WISE_CRF + "Insert", payload);
    },

    assignCRFSelectAll: (payload_data: { moduleid?: number | string|null; modulename?: string | null; categorynames?: string[] | null; searchtext?: string | null; currentpage?: number; pagesize?: number; }) => {
        return api.create(CRF_ASSIGNMENT_API.MODULE_WISE_CRF + "SelectAll", payload_data);
    },

    assignCRFDelete: (payload_data: { assignmentid?: number | string; updatereason?: string; }) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            ...payload_data,
            updatedby: user?.userid,
        };
        return api.create(CRF_ASSIGNMENT_API.MODULE_WISE_CRF + "Delete", payload);
    },

    // CRF MODULE ASSIGN / UPDATE CATEGORY (single endpoint - no separate insert)
    updateCRFModuleCategory: (payload_data: { moduleid: number | string; crfcategory: number | string; }) => {
        const user = GetUserData() as CurrentUser;
        const payload = {
            moduleid: payload_data.moduleid,
            crfcategory: payload_data.crfcategory,
            updatedby: user?.userid,
        };
        return api.create(CRF_ASSIGNMENT_API.CATEGORY_ASSIGNMENT + "Update", payload);
    },

    assignCRFCategorySelectAll: (payload_data: { searchtext?: string | null; crfcategory?: number | string | null; currentpage?: number; pagesize?: number; ispagination?: boolean; }) => {
        return api.create(CRF_ASSIGNMENT_API.CATEGORY_ASSIGNMENT + "SelectAll", payload_data);
    },
};
